module.exports = __webpack_public_path__ + "img/workflow-icon.0cc2818e.svg";